export default "__VITE_ASSET__CqZ3MYLG__"